import type { AccountSplitItem, AccountSplitStatus } from '@/types'

// splitStatusClass maps an account-split status to its dashboard status-chip
// CSS class. Co-located with the corresponding itemStatusClass so the two
// mappings stay in sync.
export const splitStatusClass = (status: AccountSplitStatus): string => {
  switch (status) {
    case 'draft':
      return 'status-grey'
    case 'dry_run_ok':
      return 'status-info'
    case 'executing':
      return 'status-warning'
    case 'partial_failure':
      return 'status-error'
    case 'completed':
      return 'status-success'
    case 'aborted':
      return 'status-grey'
    default:
      return 'status-grey'
  }
}

export const itemStatusClass = (status: AccountSplitItem['status']): string => {
  switch (status) {
    case 'pending':
      return 'status-grey'
    case 'in_progress':
      return 'status-warning'
    case 'succeeded':
      return 'status-success'
    case 'failed':
      return 'status-error'
    case 'skipped':
      return 'status-info'
    default:
      return 'status-grey'
  }
}
